


















































































// Importing Components
import TheTownSelect from '@/components/addresses/TheTownSelect.vue';
import BaseInputField from '@/ui/BaseInputField.vue';
import BaseLoadingAnimation from '@/ui/BaseLoadingAnimation.vue';
import BaseButton from '@/ui/BaseButton.vue';

export default {
    name: 'TheFormRestaurants1',
    components: {
        TheTownSelect,
        BaseInputField,
        BaseButton,
        BaseLoadingAnimation,
    },
    props: {
        restaurant: Object,
        errors: Array,
    },
    data() {
        return {};
    },
    methods: {
        next() {
            this.$emit('next');
        },
    },
};
